module.exports = __webpack_public_path__ + "img/118002.005a076.png";